// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"YJ-z","carouselContainer":"ZJ-z"};